import { commonActions } from "@common/redux/common/actions";
import { ICommonReducerState, ILoadingData } from "@common/redux/common/interface";
import config from "@config/index";

export const initialState: ICommonReducerState = {
  isLeftNavigationBarVisible: false,
  config: config,
  commonLoader: {
    isLoading: false,
    isFullscreen: false
  }
};

export const commonReducer = (
  state: ICommonReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case commonActions.FETCH_ADDRESS_BY_PINCODE:
      return {
        ...state,
      };
    case commonActions.TOGGLE_LEFT_NAVIGATION_BAR_VISIBLITY:
      return {
        ...state,
        isLeftNavigationBarVisible: action.payload,
      };
    case commonActions.FETCH_COUNTRY:
      return {
        ...state,
      };
    case commonActions.FETCH_STATE:
      return {
        ...state,
      };
    case commonActions.FETCH_CITY:
      return {
        ...state,
      };
    case commonActions.UPDATE_CONFIG:
      return {
        ...state,
        config: { ...state.config, ...(action?.payload?.config ?? {}) },
      };
    case commonActions.SET_LOADER:
      const loadingData: ILoadingData = action.payload;
      return {
        ...state,
        commonLoader: { isLoading: !!loadingData.isLoading, isFullscreen: !!loadingData.isFullscreen },
      };
    default:
      return { ...state };
  }
};
